<div class="hits-title h2">{{ 'hit-melodies.title' | translate }}</div>
<div class="hits-subtitle" *ngIf="showSubtitle">{{ 'hit-melodies.subtitle' | translate }}</div>
<div class="slider slider__hits" #hitsSlider *ngIf="melodies.length > 0">
  <div class="slider__item" *ngFor="let melody of melodies" app-melody-item-slider [melody]="melody"></div>
</div>
